import {get, post} from '../index'
export default {
  // 客户管理
  getClientList (querys) {
    return get('/customerarchives/admin/getClientList', querys)
  },
  getClientTitle () {
    return get('/customerarchives/admin/getTitle')
  },
  getTempClientList (querys) {
    return get('/customerarchives/admin/getTempClientList', querys)
  },
  setTempClientList () {
    return get('/customerarchives/admin/setTempClientList')
  },
  setClientInfo (querys) {
    return post('/customerarchives/admin/setClientInfo', querys)
  },
  getClientInfo (querys) {
    return get('/customerarchives/admin/getClientInfo', querys)
  },
  getClientStaffsFollowCustomerId (querys) {
    return get('customerarchives/admin/allot', querys)
  },
  // 分配客户
  distributionClient (querys) {
    return post('customerarchives/admin/allot', querys)
  },
  delFile (querys) {
    return get('/customerarchives/admin/delFile', querys)
  },
  exportCustomerList (querys) {
    return get('/customerarchives/admin/exportCustomer', querys)
  },
  // 获取分配员工的客户列表
  importClient (querys) {
    return post('customerarchives/admin/importCustomer', querys)
  },
  // 指标分类
  getIndicatorClassifyList (querys) {
    return get('/customerarchives/admin/getClassifyList', querys)
  },
  getIndicatorClassifyListAll (querys) {
    return get('/customerarchives/admin/getClassifyListAll', querys)
  },
  setIndicatorClassify (querys) {
    return post('/customerarchives/admin/setClassify', querys)
  },
  getIndicatorClassifyInfo (querys) {
    return get('/customerarchives/admin/getClassify', querys)
  },
  delIndicatorClassify (querys) {
    return get('/customerarchives/admin/delClassify', querys)
  },
  // 指标模板
  getTemplateIndicatorClassifyInfo (querys) {
    return get('/customerarchives/admin/AdminIndicatorTemplate/getClassify', querys)
  },
  setTemplateIndicator (querys) {
    return post('/customerarchives/admin/AdminIndicatorTemplate/setTemplate', querys)
  },
  getTemplateIndicatorList (querys) {
    return get('/customerarchives/admin/AdminIndicatorTemplate/getList', querys)
  },
  getTemplateIndicatorListAll (querys) {
    return get('/customerarchives/admin/AdminIndicatorTemplate/getListAll', querys)
  },
  getTemplateIndicatorInfo (querys) {
    return get('/customerarchives/admin/AdminIndicatorTemplate/getInfo', querys)
  },
  delTemplateIndicator (querys) {
    return get('/customerarchives/admin/AdminIndicatorTemplate/del', querys)
  },
  // 服务方案
  getServiceProgrammeInfo(querys) {
    return get('/customerarchives/admin/AdminServiceProgramme/get', querys)
  },
  getServiceProgrammeList(querys) {
    return get('/customerarchives/admin/AdminServiceProgramme/list', querys)
  },
  getServiceProgrammeListAll(querys) {
    return get('/customerarchives/admin/AdminServiceProgramme/listAll', querys)
  },
  setServiceProgramme(querys) {
    return post('/customerarchives/admin/AdminServiceProgramme/set', querys)
  },
  delServiceProgramme(querys) {
    return get('/customerarchives/admin/AdminServiceProgramme/del', querys)
  },
  getServiceProgrammeIndicatorTemplate(querys) {
    return get('/customerarchives/admin/AdminServiceProgramme/getTemplate', querys)
  },
  // 指标记录
  getIndicatorRecordList (querys) {
    return get('/customerarchives/admin/AdminIndicatorRecord/list', querys)
  },
  setIndicatorRecord (querys) {
    return post('/customerarchives/admin/AdminIndicatorRecord/set', querys)
  },
  getIndicatorRecordInfo (querys) {
    return get('/customerarchives/admin/AdminIndicatorRecord/get', querys)
  },
  delIndicatorRecord (querys) {
    return get('/customerarchives/admin/AdminIndicatorRecord/del', querys)
  },
  getIndicatorRecordListAll (querys) {
    return get('/customerarchives/admin/AdminIndicatorRecord/listAll', querys)
  },
  // 服务记录
  getServiceRecordList (querys) {
    return get('/customerarchives/admin/AdminServiceRecord/list', querys)
  },
  setServiceRecord (querys) {
    return post('/customerarchives/admin/AdminServiceRecord/set', querys)
  },
  getServiceRecordInfo (querys) {
    return get('/customerarchives/admin/AdminServiceRecord/get', querys)
  },
  delServiceRecord (querys) {
    return get('/customerarchives/admin/AdminServiceRecord/del', querys)
  },
  // 合同
  getContractList (querys) {
    return get('/customerarchives/admin/AdminContract/list', querys)
  },
  setContract (querys) {
    return post('/customerarchives/admin/AdminContract/set', querys)
  },
  getContractInfo (querys) {
    return get('/customerarchives/admin/AdminContract/get', querys)
  },
  delContract (querys) {
    return get('/customerarchives/admin/AdminContract/del', querys)
  },
  getTitleManage (querys) {
    return get('/customerarchives/admin/AdminTitleManage/get', querys)
  },
  setTitleManage (querys) {
    return post('/customerarchives/admin/AdminTitleManage/set', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/customerArchives.js